// Cockpit revamp — Enrolments tab.
//
// Wraps the existing CampaignEnrolmentsPanel so the cockpit reuses the
// data hooks + DataTable + filter UI without re-implementing them. The
// panel provides its own Card wrapper; the cockpit center pane is a
// Card already, so we render the panel contents directly inside.
//
// We keep the wrapping Card from the panel for now — duplicate borders
// would be awkward, but the panel's "Enrol contact" CTA + filter Select
// belong inside its own card. Better duplication than rewriting both.
import React from 'react';

import CampaignEnrolmentsPanel from '../CampaignEnrolments';

interface CampaignEnrolmentsTabProps {
  campaignId: string;
}

const CampaignEnrolmentsTab: React.FC<CampaignEnrolmentsTabProps> = ({
  campaignId,
}) => <CampaignEnrolmentsPanel campaignId={campaignId} />;

export default CampaignEnrolmentsTab;
